import { createGlobalState } from '@vueuse/core';


export const useExperienceFragmentContent = createGlobalState(
	() => {
		return {};
	},
);
